import { IDmCoSoActionTypes } from "../../action-types/category/IDmCoSoActions";
import { IDmCoSoReducer } from "../../reducer-model/category/IDmCoSoReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDmCoSoReducer = {
  status: eReducerStatusBase.is_not_initialization,
  coSos: [],
};
export const coSoReducer = (
  state: IDmCoSoReducer = iniState,
  action: IDmCoSoActionTypes
): IDmCoSoReducer => {
  switch (action.type) {
    case "CO_SO_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "CO_SO_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        coSos: action.payload
          ?.sort((a, b) => a.id_co_so - b.id_co_so)
          ?.sort((a, b) => a.stt - b.stt),
      };
    case "CO_SO_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
